var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3560(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    transform: "translate(-918 -689)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(918 689)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_21._Verified",
    "data-name": "21. Verified",
    d: "M46.924,29.029a6.334,6.334,0,0,1,0-7.432l1.6-2.217a2.111,2.111,0,0,0,.3-1.9,2.149,2.149,0,0,0-1.351-1.351l-2.6-.844a6.306,6.306,0,0,1-4.37-6.017V6.523A2.111,2.111,0,0,0,37.74,4.517l-2.618.844a6.334,6.334,0,0,1-7.073-2.3L26.445.843a2.187,2.187,0,0,0-3.42,0l-1.6,2.217a6.334,6.334,0,0,1-7.073,2.3L11.73,4.517A2.111,2.111,0,0,0,8.964,6.523V9.267a6.306,6.306,0,0,1-4.37,6.017L2,16.129A2.149,2.149,0,0,0,.646,17.48a2.111,2.111,0,0,0,.3,1.9l1.6,2.217a6.334,6.334,0,0,1,0,7.432l-1.6,2.217a2.111,2.111,0,0,0-.3,1.9A2.149,2.149,0,0,0,2,34.5l2.6.845a6.306,6.306,0,0,1,4.37,6.017V44.1a2.111,2.111,0,0,0,2.766,2.006l2.6-.844a6.321,6.321,0,0,1,7.094,2.3l1.6,2.217a2.122,2.122,0,0,0,3.42,0l1.6-2.217a6.334,6.334,0,0,1,7.094-2.3l2.6.844A2.111,2.111,0,0,0,40.506,44.1V41.358a6.306,6.306,0,0,1,4.37-6.017l2.6-.845a2.149,2.149,0,0,0,1.351-1.351,2.111,2.111,0,0,0-.3-1.9ZM34.679,22.583,24.123,33.139a2.111,2.111,0,0,1-2.985,0L14.8,26.805a2.111,2.111,0,1,1,2.986-2.986l4.835,4.841L31.688,19.6a2.111,2.111,0,1,1,2.986,2.986Z",
    transform: "translate(929.46 699.98)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3560);
export default __webpack_public_path__ + "static/media/Group 3560.431a36433f03f5791854944c65f08e17.svg";
export { ForwardRef as ReactComponent };